module.exports = __webpack_public_path__ + "img/document-pdf-outline.a5dc9c15.svg";